<template>
  <div class="card-edit card-theme card-edit-new-theme project-view" :key="refreshDetail" v-on="dirtyListeners">
    <card-edit-subheader
      v-if="cardLoaded"
      :module="card.__t"
      :type="type"
      :card="card"
    >
    </card-edit-subheader>
    <div class="edit-body">
      <div
        class="has-background-grey-lighter card-basic column"
        v-if="cardLoaded"
      >
        <div class="is-flex hero-header is-size-3 columns is-marginless mb-3">
          <div
            class="column is-4 is-flex is-align-items-flex-end is-align-items-center"
          >
            <i class="has-text-white image is-32x32" :class="getDynamicClasses">
            </i>
            <h3 class="is-italic has-text-weight-bold">Template Name:</h3>
            <input
              class="input has-text-weight-bold generic-input"
              v-model="card.templateName"
            />
          </div>
          <div
            class="column is-4 is-flex is-align-items-flex-end is-align-items-center"
          >
            <h3 class="is-italic has-text-weight-bold">Template ID:</h3>
            <input
              class="input has-text-weight-bold generic-input"
              v-model="card.templateId"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="columns">
              <div class="column">
                <div class="field mb-5">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    Name
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.name"
                    />
                  </div>
                </div>
                <div class="field">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                  >
                    ID
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.financialId"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <h3
                    class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                  >
                    Activity
                  </h3>
                  <div class="control is-flex-grow-1">
                    <input
                      class="input generic-input"
                      v-model.trim="card.activity"
                    />
                  </div>
                </div>
                <field-user-select
                  titleLabel="Owner"
                  :isEditing="true"
                  :key="allCompanyUsers.length"
                  :options="allCompanyUsers"
                  :value="card.owner.user"
                  @update:value="(val) => $_.set(card, 'owner.user', val)"
                ></field-user-select>
              </div>
              <div class="column">
                <field-location-select
                  titleLabel="Delivery"
                  :isEditing="true"
                  :value="card.baseDelivery.location"
                  :options="allLocations"
                  @update:value="(val) => (card.baseDelivery.location = val)"
                ></field-location-select>
                <div class="field string-select">
                  <mf-multi-select
                    v-model="card.baseDelivery.vendor"
                    :options="allCompanyVendors"
                    :multiple="false"
                    :searchable="true"
                    label="name"
                    track-by="_id"
                    :disabled="card.isDefault"
                    :allow-empty="false"
                    titleLabel="Vendor"
                    @select="vendorSelected($event)"
                    labelClass="has-text-black-bis is-italic is-size-3"
                  >
                  </mf-multi-select>
                </div>
              </div>
              <div class="column pt-0 is-3-fullhd is-4-desktop">
                <h4 class="title is-capitalized">dates</h4>
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <h3
                        class="has-text-black-bis is-italic is-size-3 has-text-weight-bold"
                      >
                        Default Item Lead Time
                      </h3>
                    </div>
                    <div class="column">
                      <input
                        class="input generic-input"
                        v-model.number="card.leadTime"
                        type="number"
                        min="0"
                        max="730"
                        @keypress="rejectDot($event)"
                      />
                    </div>
                    <div class="column is-narrow">
                      <span>Days</span>
                    </div>
                  </div>
                  <div>
                    If no Order By lead time is provided in the parts
                    Catalog,then set it here.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="columns"
          :class="
            !accordionStatus
              ? 'hide-column'
              : 'pm-edit-show-column pm-edit-scroll'
          "
        >
          <div class="column">
            <div class="columns">
              <div class="column" v-for="col of subDetails" :key="col.label">
                <base-column :fields="col.fields" :card="card"></base-column>
              </div>
              <div class="column">
                <h3
                  class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height"
                >
                  <i class="fas fa-dollar-sign"></i> Financials
                </h3>
                <h3
                  class="has-text-black-bis is-italic is-size-3 has-text-weight-bold line-height mb-3"
                >
                  Purchase Order
                </h3>
                <input
                  v-model="card.purchaseOrder"
                  placeholder="Purchase Order"
                  class="input"
                  :disabled="
                    $_.get(companyData, 'generatePon', false) ||
                    $_.get(projectData, 'generatePon', false)
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="column card-collapse is-clickable"
          @click="() => (accordionStatus = !accordionStatus)"
        >
          <div class="is-size-5 has-text-weight-normal is-capitalized">
            <i
              class="icon-disclosearrow"
              :class="!accordionStatus ? '' : 'rotate-180'"
            ></i>
            <span class="is-italic" v-if="!accordionStatus">show details</span>
            <span class="is-italic" v-else>hide details</span>
          </div>
        </div>
      </div>
      <div
        class="card-edit-item-table has-background-grey-lighter temp-mat-order" id="temp-last-child"
      >
        <mf-detail-row
          v-if="cardLoaded"
          :rowData="card"
          :refreshCard="loadCard"
          @tabName="setTabName"
          @itemQtyUpdate="setItemQtyChanged"
          :tabLabel="selectedTabName"
          :cfColumns="cfColumns"
        >
        </mf-detail-row>
      </div>
    </div>
    <footer
      v-if="isDirty && hasPermission"
      class="card-footer"
      :class="buttonPosition === 'right' ? 'button-align-right' : ''"
    >
      <div class="buttons">
        <button class="button is-outlined is-danger" @click="loadCard">
          discard changes
        </button>
        <button class="button is-success" @click="save" :disabled="disableSave">
          save changes
        </button>
      </div>
    </footer>
    <transition name="slide">
      <item-document-slider
        v-if="isFileListVisible"
        :isActive="isFileListVisible"
        :rowData="selectedItem"
        :rowField="rowField"
        @close="closeDocumentSlider"
        :card="card"
        :checkListOrder="checkListOrder"
      >
      </item-document-slider>
    </transition>
    <transition name="slide">
      <notes-icon-slider
        v-if="isSlideNotesActive"
        :isActive="isSlideNotesActive"
        :rowData="selectedItem"
        @close="closeNotesSlider"
        :isDisabled="isNotesDisabled"
        :isItem="isItem"
      >
      </notes-icon-slider>
    </transition>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  onBeforeMount,
  onBeforeUnmount,
  nextTick,
  inject,
  computed,
  provide,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import CardEditSubHeader from "@/components/card-edit/CardEditSubheader.vue";
import NotesIconSlider from "@/components/modals/NotesIconSlider.vue";
import ItemDocumentSlider from "@/components/modals/ItemDocumentSlider.vue";
import MfDetailRow from "@/components/table-fields/MfDetailRow.vue";
import CardFooter from "@/components/card-edit/CardFooter.vue";
import CardEditMixin from "@/components/mixins/CardEditMixin";
import { filter, flatMap, isEmpty, set } from "lodash";
import ExcelInvalidData from "@/components/modals/ExcelInvalidData.vue";
import MaterialTemplates from "@/models/MaterialTemplates";
import Users from "@/models/Users";
import Locations from "@/models/Locations";
import QtyInput from "@/components/fields/QtyInput.vue";
import Validations from "@/utils/Validations";
import MfDate from "@/components/abstract/MfDate.vue";
import BaseCardColumn from "@/components/card-edit/BaseCardColumn.vue";
import Vendors from "@/models/Vendors";
import Projects from "@/models/Projects";
import { useToast } from "vue-toastification";
import PermissionMixin from '@/components/mixins/PermissionMixin';


export default {
  name: "material-template-edit",
  components: {
    "card-edit-subheader": CardEditSubHeader,
    "mf-detail-row": MfDetailRow,
    "card-footer": CardFooter,
    "notes-icon-slider": NotesIconSlider,
    "item-document-slider": ItemDocumentSlider,
    ExcelInvalidData,
    QtyInput,
    MfDate,
    "base-column": BaseCardColumn,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { onInitDirty, templateCardValidations, saveCard } = CardEditMixin();
    const emitter = inject("emitter");
    const router = useRouter();
    const store = useStore();
    const toast = useToast();
    const { getPermissionValues } = PermissionMixin();
    // data
    const data = reactive({
      card: {},
      cardLoaded: false,
      isLoading: false,
      type: "",
      allCompanyUsers: [],
      allLocations: [],
      accordionStatus: false,
      selectedTabName: "",
      itemQtyChanged: false,
      selectedItem: {},
      rowField: {},
      isFileListVisible: false,
      checkListOrder: {},
      isSlideNotesActive: false,
      isNotesDisabled: false,
      isItem: false,
      allCompanyVendors: [],
      companyData: {},
      projectData: {},
      hasPermission: true,
      refreshDetail: 0,
    });

    const clockObj = {
      inputProps: {
        type: "number",
        min: "0",
        max: "999",
        step: "1",
        isLeft: true,
        fromWorkStep: true,
        showNum: true,
        fieldDirtyRequired: true,
      },
      prop: "estHrs",
    };

    const subDetails = [
      {
        label: "col1",
        fields: [
          {
            name: "field-file-list",
            prop: "simpleFiles",
            label: "files",
          },
        ],
      },
      {
        label: "col2",
        fields: [
          {
            name: "field-notes",
            prop: "currentNote",
            label: "Notes",
          },
        ],
      },
      {
        label: "col3",
        fields: [
          {
            name: "field-tags",
            prop: "tags",
            label: "Tags",
          },
        ],
      },
    ];
    onInitDirty(data);

    const loadCard = async () => {
      try {
        data.isLoading = true;
        await store.getters.userPromise;
        data.type = store.state.activeScreen;
        onInitDirty(data);
        data.card = await MaterialTemplates.getTemplates({
          cardId: props.cardId,
          projectId: props.projectId,
        });
        data.cardLoaded = true;
        data.refreshDetail += 1;
        data.card.items.forEach((item) => {
          set(item, "isEditing", true);
          if (!item.simpleMemos || item.simpleMemos.length === 0) {
            item.newFTD("memos");
          }
        });
        await getAllCompanyUsers();
        const locs = await Locations.allLocationForUser({
          companyIds: data.card.getInvolvedCompanies(),
          projectId: data.card.project._id,
        });
        data.allLocations = Locations.groupLocations(
          locs,
          store.state.companyData
        );
        data.allCompanyVendors = (
          await Vendors.getVendors({ limit: 1000 })
        ).data;
        data.companyData = await store.state.companyData;
        data.projectData = await Projects.getOne(data.card.project._id);
      } catch (e) {
        console.error("Error: ", e);
      } finally {
        data.isLoading = false;
      }
    };

    onBeforeMount(async () => {
      data.hasPermission = !(getPermissionValues({
        permissionModule: 'app&projects',
        type: 'company_templates',
      }))
      await loadCard();
      data.cardLoaded = true;
      data.itemsLoaded = true;
    });

    const getDynamicClasses = computed(() => {
      const routeMeta = router.currentRoute.value.meta;
      let classes = "";
      if (routeMeta.activeViewColor) {
        classes = `${routeMeta.activeViewColor} `;
      }
      if (routeMeta.cardEditIcon) {
        classes += `icon-${routeMeta.cardEditIcon}`;
      }
      return classes;
    });

    const setStageUsed = (val) => {
      set(data.card, "stageUsed", val.toLowerCase());
    };

    const getAllCompanyUsers = async () => {
      const user = store.state.userData;
      let allUsers;
      const orderCreator = {
        _id: "(Order Creator)",
        name: "(Order Creator)",
        companyName: user.companyName,
      };
      if (["MatTemplates", "ProdTemplates"].includes(data.card.__t)) {
        allUsers = (await Users.allUsers({ limit: 1000 })).data;
        allUsers = filter(allUsers, (user) => user.activated && !user.archived);
        allUsers.unshift(orderCreator);
      }

      data.allCompanyUsers = Users.groupUsers(allUsers);
    };

    const rejectDot = (event) => {
      if (event.keyCode === 46) event.preventDefault();
    };

    const disableLeadDate = (date) => {
      return typeof date !== "number";
    };

    const validateFields = async (cf) => {
      const isValid = await Validations.validateCustomFields(
        cf,
        data.card,
        store.state.userData,
        false,
        "prod-custom-fields"
      );
      return isValid;
    };

    const setTabName = (val) => {
      data.selectedTabName = val;
    };

    const setItemQtyChanged = (val) => {
      data.itemQtyChanged = val;
    };

    const closeDocumentSlider = () => {
      data.isFileListVisible = false;
    };

    emitter.on("toggle:itemDocsSlider", (payload) => {
      data.isSlideNotesActive = !payload.isActive;
      data.selectedItem = payload.data;
      data.rowField = payload.rowField;
      data.isFileListVisible = payload.isActive;
      data.checkListOrder = payload.checkListOrder || data.checkListOrder;
    });

    emitter.on("toggle:notesSlider", (payload) => {
      // *Listen* for event
      data.isFileListVisible = !payload.isActive;
      data.selectedItem = payload.data;
      data.isItem = payload.isItem;
      data.isSlideNotesActive = payload.isActive;
      data.isNotesDisabled = payload.isDisabled;
    });

    onBeforeUnmount(() => {
      emitter.off("toggle:itemDocsSlider");
      emitter.off("toggle:notesSlider");
    });

    const closeNotesSlider = () => {
      data.isSlideNotesActive = false;
      data.selectedItem = {};
    };

    const save = async () => {
      try {
        data.isLoading = true;
        const validationResult = templateCardValidations(data.card);
        if (validationResult) {
          toast.error(validationResult);
          return false;
        }
        await saveCard(data.card._id, "", data.card);
        await loadCard();
      } catch (e) {
        console.error("Error: ", e);
        const errMsg = e?.data?.msg || e.message;
        if (errMsg) toast.error(errMsg);
      } finally {
        data.isLoading = false;
      }
    };

    return {
      ...toRefs(data),
      getDynamicClasses,
      setStageUsed,
      clockObj,
      rejectDot,
      disableLeadDate,
      validateFields,
      subDetails,
      loadCard,
      setTabName,
      setItemQtyChanged,
      closeDocumentSlider,
      closeNotesSlider,
      save,
    };
  },
};
</script>

<style scoped>
::v-deep(.string-select .multiselect__single) {
  text-transform: capitalize;
}
.clock-width {
  width: 150px;
}
 
</style>
